import { Phone } from "lucide-react";
import { WhatsAppIcon } from "./icons";
import { BUSINESS } from "@/lib/api";
import { trackConversion } from "@/lib/gtag";

export default function StickyButtons() {
  const waText = encodeURIComponent("Hi Sudeeksha, I'd like a free quote for invisible grills.");
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3" data-testid="sticky-buttons">
      <a
        href={`https://wa.me/${BUSINESS.whatsapp}?text=${waText}`}
        target="_blank"
        rel="noreferrer"
        data-testid="sticky-whatsapp"
        onClick={trackConversion}
        aria-label="Chat with us on WhatsApp"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
      >
        <WhatsAppIcon size={30} />
      </a>
      <a
        href={`tel:+91${BUSINESS.phone}`}
        data-testid="sticky-call"
        onClick={trackConversion}
        aria-label="Call now"
        className="w-14 h-14 rounded-full bg-steel-800 text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
      >
        <Phone size={24} />
      </a>
    </div>
  );
}
